<template>
  <div class="flex flex-col gap-2">
    <LabelComponent v-if="!props.hideLabel">{{ label }}</LabelComponent>
    <textarea
      v-model="input"
      type="text"
      required
      class="border placeholder:text-gray-400 w-full py-2 px-3 leading-tight resize-none rounded-lg ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      :data-testid="props.testId || 'text-box-input'"
      :class="[
        props.classes || '',
        props.disabled
          ? 'cursor-not-allowed border-grey-light-300 bg-grey-light-50 text-gray-700'
          : 'text-grey-light-900',
      ]"
      :disabled="props.disabled"
      :placeholder="props.placeholder || 'Add a message...'"
      :rows="props.rows || 4"
      @input="onInput"
    />
  </div>
  <div v-if="error !== ''" class="flex items-center">
    <span class="text-sm font-medium text-error-500">
      {{ error }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import LabelComponent from '../ui/label/LabelComponent.vue';

const props = defineProps<{
  label?: string;
  testId?: string;
  disabled?: boolean;
  modelValue?: string;
  classes?: string;
  placeholder?: string;
  hideLabel?: boolean;
  rows?: number;
}>();

const input = ref(props.modelValue || '');
const isValid = ref(true);
const emit = defineEmits(['update:modelValue', 'update:isInputValid', 'error']);
const error = ref('');

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const value = target.value;

  input.value = value;

  emit('update:modelValue', value);
  emit('update:isInputValid', isValid.value);

  if (isValid.value) {
    error.value = '';
    emit('error', '');
  }
};

watch(isValid, (newValue) => {
  emit('update:isInputValid', newValue);
  if (newValue) {
    error.value = '';
    emit('error', '');
  }
});
</script>
